import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'Order P |||| Order P records',
      importThirdCountryM: 'M positions',
      fields: {
        id: 'ID',
      },
    },
  },
};
